import RastreamentoContent from "./RastreamentoContent";

export default function RastreamentoEntrega() {
  return <RastreamentoContent />;
}
